import { Home, CalendarRange, UserRound, Users, Compass, Briefcase, Building2 } from 'lucide-react';

export const MENTOR_NAV = [
  { id: 'home', label: 'Home', to: '/mentor', icon: Home, match: (p) => p === '/mentor' },
  { id: 'experiences', label: 'My Experiences', shortLabel: 'Experiences', to: '/mentor/experiences', icon: CalendarRange, match: (p) => p.startsWith('/mentor/experiences') || p.startsWith('/group-sessions') || p.startsWith('/sessions') },
  { id: 'profile', label: 'My Profile', shortLabel: 'Profile', to: '/mentor/profile', icon: UserRound, match: (p) => p.startsWith('/mentor/profile') },
];

export const PARENT_NAV = [
  { id: 'home', label: 'Home', to: '/parent', icon: Home, match: (p) => p === '/parent' },
  { id: 'children', label: 'My Children', shortLabel: 'Children', to: '/parent/children', icon: Users, match: (p) => p.startsWith('/parent/children') },
  { id: 'experiences', label: 'Experiences', to: '/parent/experiences', icon: CalendarRange, match: (p) => p.startsWith('/parent/experiences') || p.startsWith('/sessions') || p.startsWith('/group-sessions') },
  { id: 'internships', label: 'Internships', to: '/parent/internships', icon: Briefcase, match: (p) => p.startsWith('/parent/internships') },
  { id: 'careers', label: 'Explore Careers', shortLabel: 'Explore', to: '/careers', icon: Compass, match: (p) => p.startsWith('/careers') },
];

export const PARTNER_NAV = [
  { id: 'overview', label: 'Overview', to: '/partner', icon: Home, match: (p) => p === '/partner' },
  { id: 'programs', label: 'Programmes', to: '/partner/programs', icon: CalendarRange, match: (p) => p.startsWith('/partner/programs') || p.startsWith('/partner/offers') },
  { id: 'company', label: 'Company Profile', shortLabel: 'Company', to: '/partner/company', icon: Building2, match: (p) => p.startsWith('/partner/company') },
];

/** Routes that render their own WorkspaceLayout. */
export const SELF_WRAPPED_ROUTES = [
  '/parent', '/parent/children', '/parent/experiences', '/parent/internships',
  '/mentor', '/mentor/experiences', '/mentor/profile',
  '/partner', '/partner/programs', '/partner/offers', '/partner/company', '/partner/shortlisted',
  '/partner/interns',
];

/** Shared detail routes that should keep the workspace chrome for parent/mentor users. */
export const SHARED_DETAIL_PREFIXES = ['/sessions/', '/group-sessions/', '/parent/children/', '/parent/safety-concerns', '/parent/privacy-permissions'];
